import {
  addressValidationQueryOptions,
  UsState,
} from '@branch-messenger/willow-ui'
import { FlowCardLoading } from '@components/FlowCard'
import { AddressVerification } from '@components/RouteComponents'
import { shippingTimeQueryOptions } from '@src/queryOptions/address'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/address/')({
  loader: ({ context: { queryClient, store } }) => {
    const state = store.getState().onboarding
    const address = state.enteredAddress
    const promises: Promise<any>[] = [
      queryClient.ensureQueryData(shippingTimeQueryOptions),
    ]
    if (address) {
      promises.push(
        queryClient.ensureQueryData(
          addressValidationQueryOptions({
            address: {
              streetLine: address.address_1,
              secondary: address.address_2,
              city: address.city,
              state: address.state as UsState,
              zipcode: address.zip,
            },
          })
        )
      )
    }
    return Promise.all(promises)
  },
  component: AddressVerification,
  pendingComponent: FlowCardLoading,
})
